import Carousel from "./Carousel";
import "./Values.css";
import ZoneHeading from "./ZoneHeading";

const Values = () => {
  const Item = ({ header, text }) => {
    return (
      <div className="value-item">
        <div className="value-item-header">
          <h3>{header}</h3>
        </div>
        <div className="value-item-text">{text}</div>
      </div>
    );
  };
  return (
    <div className="values-zone">
      <div className="zone">
        <ZoneHeading id="values">Values</ZoneHeading>
        <Carousel items={[
        <Item
          header="Trust"
          text="Cultivating long-lasting relationships based on reliability, consistency, and mutual respect."
        />,
        <Item
          header="Transparency"
          text="We like to be straightforward in everything we do, making each step of our process clear along the way."
        />,
        <Item
          header="Alignment"
          text="Create an investment structure that motivates all parties through alignment of financial incentives."
        />,
        <Item
          header="Support"
          text="Providing encouragement, resources, and assistance to help management teams succeed personally and professionally."
        />,
        <Item
          header="Flexibility"
          text="Willingness to negotiate and adjust strategies or approaches when needed to achieve the best outcomes for the partnership."
        />,
        <Item
          header="Sustainability"
          text="Focus on working with companies that have positive impacts and add value to their respective communities."
        />,
        <Item
          header="Work Ethic"
          text="Maintaining a strong, proactive attitude and a commitment to excellence in all aspects of the business."
        />,
        <Item
          header="Integrity"
          text="Act as fiduciaries to our investors, prioritizing their interests above our own."
        />,
        <Item
          header="Partnership"
          text="Act as trusted counsel to management teams and establish an open forum to have candid conversations about challenging issues."
        />,
        <Item
          header="Growth"
          text="Invest to expand companies and focus on long-term business building instead of expense reduction and financial engineering."
        />,
        <Item
          header="Long-Term Focus"
          text="Prioritizing sustainable growth and long-term success over short-term gains."
        />]} />
      </div>
    </div>
  );
};

export default Values;
